import { connect } from 'react-redux';
import { Breadcrumb, Dropdown, Form, Icon, Menu, Segment } from 'semantic-ui-react';
import PageContainer from '../common/PageContainer';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { TextField } from '../common/FormFields';
import { Formik } from 'formik';
import { siteValidationSchema } from './admin.constants';
import PropertiesDropDown from '../common/PropertiesDropDown';
import CitiesDropDown from '../common/CitiesDropDown';

export const EditSite = ({ match, site, setSite, updateSite }) => {
  const id = match.params.id;

  useEffect(() => {
    if (id) {
      setSite(id);
    }
  }, [id]);

  const handleSubmit = site => updateSite(site);

  const getPage = () => (
    <Formik initialValues={site} enableReinitialize validationSchema={siteValidationSchema} onSubmit={handleSubmit}>
      {formik => (
        <>
          <Breadcrumb>
            <Breadcrumb.Section>Admin</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>
              <Link to="/admin/site">Sites</Link>
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section>Edit Site</Breadcrumb.Section>
          </Breadcrumb>

          <Menu borderless attached="top">
            <Menu.Item header>
              <Icon name="computer" />
              {site.property} ({site.city})
            </Menu.Item>

            <Menu.Menu position="right">
              <Menu.Item>
                <Dropdown text="Actions" icon="chevron down" floating labeled button className="icon">
                  <Dropdown.Menu>
                    <Dropdown.Item
                      icon="save"
                      disabled={!formik.isValid || formik.isSubmitting}
                      text="Save changes"
                      onClick={() => formik.handleSubmit(formik)}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Item>
            </Menu.Menu>
          </Menu>

          <Segment attached>
            <Form widths="equal">
              <PropertiesDropDown
                name="property"
                label="Property"
                formik={formik}
                value={formik.values.property}
                onChange={formik.handleChange}
                error={formik.touched.property && Boolean(formik.errors.property)}
                errorMessage={formik.errors.property}
              />

              <CitiesDropDown
                name="city"
                label="City"
                formik={formik}
                value={formik.values.city}
                onChange={formik.handleChange}
                error={formik.touched.city && Boolean(formik.errors.city)}
                errorMessage={formik.errors.city}
              />

              <TextField
                name="url"
                formik={formik}
                value={formik.values.url}
                onChange={formik.handleChange}
                error={formik.touched.url && Boolean(formik.errors.url)}
                errorMessage={formik.errors.url}
                label="URL"
              />
            </Form>
          </Segment>
        </>
      )}
    </Formik>
  );

  return <PageContainer>{site && site.id && getPage()}</PageContainer>;
};

const mapStateToProps = state => ({
  site: selectors.getCurrentSite(state),
});

const mapDispatchToProps = dispatch => ({
  setSite: bindActionCreators(actions.admin.setSite, dispatch),
  updateSite: bindActionCreators(actions.admin.updateSite, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSite);
